import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { LiveScoreData, LiveScoreSubscriptionData } from '../types';

export const isValidLiveScore = (obj: LiveScoreData): boolean =>
  Boolean(obj?.data?.getLiveScoreWidget && !isEmptyObject(obj.data.getLiveScoreWidget));

export const isValidLiveScoreSubscription = (obj: LiveScoreSubscriptionData): boolean =>
  Boolean(obj?.data?.onUpdateLiveScoreById && !isEmptyObject(obj.data.onUpdateLiveScoreById));